<template>
  <v-dialog persistent max-width="600px" v-model="model" scrollable>
    <v-card height="500px">
      <v-card-title class="ma-0 pa-0">
        <v-row class="ma-0 pa-0 mt-3" justify="start">
          <v-col cols="3" class="ma-0 pa-0">
            <v-row class="ma-0 pa-0" justify="start" align="center">
              <v-btn @click="model = false" text class="text-none primary--text"
                >{{ labels.CLOSE }}
              </v-btn>
            </v-row>
          </v-col>
          <v-col cols="6" class="ma-0 pa-0">
            <v-row
              justify="center"
              align="center"
              class="vetalfa-row ma-0 pa-0 px-4"
            >
              <p class="text-center vetalfa-dialog-title pt-1 pa-0 ma-0">
                Adição de Fotos
              </p>
            </v-row>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text class="ma-0 pa-0 py-4">
        <vetalfa-section-title
          prop="Selecione o arquivo que você deseja adicionar:"
          class="ma-0 pa-0"
        >
          <v-row class="ma-0 pa-0 pa-2">
            <v-col class="pa-2 ma-0" cols="8">
              <v-file-input
                accept="image/png,image/jpeg"
                placeholder="Selecione"
                hide-details
                v-model="imageModel"
                :rules="rules"
                :disabled="loading"
                outlined
                dense
              ></v-file-input>
            </v-col>
            <v-col class="pa-2 ma-0" cols="4">
              <v-btn
                @click="addPhoto()"
                :disabled="!imageModel"
                block
                :loading="loading"
                color="primary"
                class="text-none"
                >Adicionar imagem</v-btn
              >
            </v-col>
          </v-row>
        </vetalfa-section-title>
        <vetalfa-section-title prop="Fotos adicionadas na seção">
          <v-row
            class="ma-0 pa-4"
            v-for="photo in photosArray"
            :key="photo.name"
          >
            <v-card class="ma-0 pa-0">
              <v-img
                :src="photo.src"
                class="white--text align-end"
                gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                height="200px"
              >
                <v-card-title v-text="photo.name"></v-card-title>
              </v-img>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn icon @click="removePhoto(photo)">
                  <v-icon>{{ mdiTrashCanOutline }}</v-icon>
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-row>
        </vetalfa-section-title>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
import labels from "@/constants/labels.js";
import { mdiTrashCanOutline } from "@mdi/js";
export default {
  name: "PhotosManagement",
  props: {
    sectionPhotos: { type: Array, required: true },
  },
  computed: {
    ...mapGetters("general", ["loading"]),
    ...mapGetters("management", ["itemId", "photosModel"]),
    model: {
      get() {
        return this.photosModel;
      },
      set(val) {
        this.setPhotosModel(val);
      },
    },
  },
  methods: {
    ...mapActions("management", ["insertPhoto"]),
    ...mapMutations("management", ["setPhotosModel"]),
    addPhoto: async function () {
      if (this.photosArray.length != 0) {
        alert("Só é permitido o cadastro de uma foto por seção.");
        return;
      }
      const name =
        this._getTimestamp() + this.imageModel.name.split("/").join("");
      const path = `items/${this.itemId}/`;
      const src = await this.insertPhoto({
        type: this.imageModel.type,
        file: this.imageModel,
        name,
        path,
      });
      this.photosArray.push({
        name,
        path,
        src,
      });
      this.imageModel = null;
      this.$emit("setPhotos", this.photosArray);
    },
    removePhoto(photo) {
      this.photosArray = this.photosArray.filter((p) => {
        return p.name !== photo.name;
      });
      this.$emit("setPhotos", this.photosArray);
    },
  },
  watch: {
    model() {
      this.productImage = null;
    },
    sectionPhotos(val) {
      this.photosArray = val;
    },
  },
  data() {
    return {
      imageModel: null,
      rules: [
        (value) =>
          !value ||
          value.size < 5000000 ||
          "Arquivo não pode ser maior que 5MB!",
      ],
      photosArray: [],
      labels,
      mdiTrashCanOutline,
    };
  },
  created() {
    this.photosArray = this.sectionPhotos;
  },
};
</script>
